export default {
    PENDING_EXPORT_STATUS: 'Pending',
    RUNNING_EXPORT_STATUS: 'Running',
    COMPLETED_EXPORT_STATUS: 'Completed',
    FAILED_EXPORT_STATUS: 'Failed',

    EXPIRATION_ALERT_AFTER_DAYS: 2,
    FREE_VIDEO_DAYS_LIMIT: 10,

    // Must match MediaConstants.MyVideosPageSize on the server.
    VIDEOS_PAGE_SIZE: 10
}